/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymAppointmentsStep_7Aliases {
  AUTOCOMPLETE_ESTABLISHMENT = 'autocomplete-establishment',
  AUTOCOMPLETE_SORT = 'autocomplete-sort',
  CARD_SUGGESTION_ITEM = 'card-suggestion-item',
  CHECKBOX_ONLY_TELECONSULTATION = 'checkbox-only-teleconsultation',
  CONTEXTUAL_BAR_SUGGESTION_LIST = 'contextual-bar-suggestion-list',
  DATE_PICKER_SCHEDULE_RANGE = 'date-picker-schedule-range',
  DECK_SUGGESTION_GROUPS = 'deck-suggestion-groups',
  DECK_SUGGESTION_ITEMS = 'deck-suggestion-items',
  FIELD_ESTABLISHMENT = 'field-establishment',
  FIELD_SORT = 'field-sort',
  FIELD_TELECONSULTATION = 'field-teleconsultation',
  FILTER_SUGGESTION_TIMES = 'filter-suggestion-times',
  LAYOUT_SUGGESTION = 'layout-suggestion',
  LAYOUT_SUGGESTIONS = 'layout-suggestions',
  LOADER = 'loader',
  LOADER_FILTER = 'loader-filter',
  MAPPER_ESTABLISHMENT = 'mapper-establishment',
  MAPPER_SORT = 'mapper-sort',
  MAPPER_SUGGESTION_GROUPS = 'mapper-suggestion-groups',
  PANEL_CHOOSEN_ITEMS = 'panel-choosen-items',
  PANEL_CHOOSEN_ITEMS_TEXT = 'panel-choosen-items-text',
  PANEL_LOAD_CONTENT = 'panel-load-content',
  PANEL_LOADER = 'panel-loader',
  PANEL_NOTIFICATION_SUGGESTION = 'panel-notification-suggestion',
  PANEL_SUGGESTION_GROUPS = 'panel-suggestion-groups',
  PANEL_SUGGESTION_LIST = 'panel-suggestion-list',
  PANEL_SUGGESTIONS = 'panel-suggestions',
  PANEL_WEEK_DAYS = 'panel-week-days',
  PSEUDONYM_APPOINTMENT_SUGGESTION_CARD = 'pseudonym-appointment-suggestion-card',
  PSEUDONYM_SUGGESTION_CARD_ITEM = 'pseudonym-suggestion-card-item',
  TEXT_CHOOSEN_ITEMS = 'text-choosen-items',
  TEXT_ESTABLISHMENT = 'text-establishment',
  TEXT_SORT = 'text-sort',
  TOAST_NOTIFICATION_WAITING_LIST = 'toast-notification-waiting-list',
  TRAIL_CHOOSEN_ITEMS = 'trail-choosen-items',
}
export { PseudonymAppointmentsStep_7Aliases };
